<div class="sidebar">
  @if (dialogOptions.closable) {
    <button [mat-dialog-close]="componentResult" class="dialog-close" mat-mini-fab aria-label="Close Sidebar"
      >
      <mat-icon title="Close Sidebar">close</mat-icon>
    </button>
  }

  @if (initialized) {
    <div class="content">
      <form [formGroup]="inputForm">
        <div class="container">
          <!-- Invite Scope -->
          <section>
            @if (!editing) {
              <div class="mat-body-2 row">Invite to:</div>
            }
            @if (!editing) {
              <div class="mat-body capitalize">
                @if (invitation.site?.id) {
                  Site {{invitation.site?.name}}
                }
                @if (!invitation.site?.id && invitation.project?.id) {
                  Project {{invitation.project?.name}}
                }
              </div>
            }
            @if (editing) {
              <mat-form-field>
                <mat-label>Invite to</mat-label>
                <mat-select formControlName="scope_id" [errorStateMatcher]="matcher"
                  (selectionChange)="onScopeChange($event.value)">
                  @for (scope of scopes; track scope) {
                    <mat-option [value]="scope.id">
                      <div [class.pad-l-20]="scope.child">{{scope.name}}</div>
                    </mat-option>
                  }
                </mat-select>
                @if (inputForm.controls.scope_id.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.scope_id.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.scope_id.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            }
          </section>
          <!-- /Invite Scope -->
          <!-- Role -->
          <section>
            @if (!editing) {
              <div class="mat-body-2 row">Role:</div>
            }
            @if (!editing) {
              <div class="mat-body capitalize">
                @if (invitation.role?.id) {
                  {{invitation.role?.name}}
                }
                @if (!invitation.role?.id) {
                  {{invitation.role_code}}
                }
              </div>
            }
            @if (editing) {
              <mat-form-field>
                <mat-label>Role</mat-label>
                <mat-select formControlName="role_code" [errorStateMatcher]="matcher">
                  @for (role of roles; track role) {
                    <mat-option [value]="role.code" [disabled]="role.scope !== _scopeType">
                      {{role.label}}
                    </mat-option>
                  }
                </mat-select>
                @if (inputForm.controls.role_code.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.role_code.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.role_code.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            }
          </section>
          <!-- /Role -->
          <!-- SSO Option -->
          <section>
            <mat-checkbox [formControl]="inputForm.get('sso_flag')" [ngClass]="{ 'disabled-checkbox': !editing }">Uses sso</mat-checkbox>
          </section>
          <!-- /SSO Option -->
          <!-- First Name -->
          <section>
            <div class="mat-body-2 row">First name:</div>
            @if (!editing) {
              <div class="mat-body capitalize">{{invitation.first_name}}</div>
            }
            @if (editing) {
              <mat-form-field>
                <mat-label>First name</mat-label>
                <input matInput type="text" autocomplete="off" formControlName="first_name"
                  [errorStateMatcher]="matcher" />
                @if (inputForm.controls.first_name.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.first_name.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.first_name.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            }
          </section>
          <!-- /First Name -->
          <!-- Last Name -->
          <section>
            <div class="mat-body-2 row">Last name:</div>
            @if (!editing) {
              <div class="mat-body capitalize">{{invitation.last_name}}</div>
            }
            @if (editing) {
              <mat-form-field>
                <mat-label>Last name</mat-label>
                <input matInput type="text" autocomplete="off" formControlName="last_name"
                  [errorStateMatcher]="matcher" />
                @if (inputForm.controls.last_name.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.last_name.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.last_name.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            }
          </section>
          <!-- /Last Name -->
          <!-- Email -->
          <section>
            <div class="mat-body-2 row">Email:</div>
            @if (!editing) {
              <div class="mat-body capitalize">{{invitation.email}}</div>
            }
            @if (editing) {
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input matInput type="email" autocomplete="off" formControlName="email" [errorStateMatcher]="matcher" />
                @if (inputForm.controls.email.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.email.hasError('email')) {
                  <mat-error>
                    Please enter a valid email
                  </mat-error>
                }
                @if (inputForm.controls.email.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.email.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            }
          </section>
          <!-- /Email -->
          <!-- Phone -->
          <section>
            <div class="mat-body-2 row">Phone:</div>
            @if (!editing) {
              <div class="mat-body">{{invitation.phone}}</div>
            }
            @if (editing) {
              <mat-form-field>
                <mat-label>Phone</mat-label>
                <input matInput type="email" autocomplete="off" formControlName="phone" [errorStateMatcher]="matcher" />
                @if (inputForm.controls.phone.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.phone.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.last_name.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            }
          </section>
          <!-- /Phone -->
          @if (!editing && invitation.inviter?.id) {
            <section>
              <div class="mat-body-2 row">Invited by:</div>
              <div class="mat-body">{{invitation.inviter.name}} on {{invitation.created_at | dateFormat: 'long'}}</div>
            </section>
          }
          <!-- Form Actions -->
          <section>
            @if (editing) {
              <div class="row">
                <button mat-stroked-button color="primary" (click)="onSubmit()">
                  <ng-container>Invite</ng-container>
                </button>
                <button mat-stroked-button (click)="onCancel()">Cancel</button>
              </div>
            }
          </section>
          <!-- Form Actions -->
        </div>
      </form>
    </div>
  }
</div>
